// (function () {
//   if (window.__cartRecommendationLoaded) return;
//   window.__cartRecommendationLoaded = true;

//   var cache = {}; // baseId -> rendered HTML (no flicker on re-render)

//   function root() {
//     return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
//   }

//   function card(p) {
//     var price = '₹' + (p.price / 100).toFixed(2).replace(/\.00$/, '');
//     return '<div class="cart-recs__item">'
//       + '<a class="cart-recs__img" href="' + p.url + '"><img loading="lazy" src="' + p.featured_image + '" alt="' + (p.title || '').replace(/"/g, '&quot;') + '"></a>'
//       + '<div class="cart-recs__info">'
//       + '<a class="cart-recs__name" href="' + p.url + '">' + p.title + '</a>'
//       + '<span class="cart-recs__price">' + price + '</span>'
//       + '<button type="button" class="cart-recs__add" data-id="' + p.variants[0].id + '">Add to cart</button>'
//       + '</div></div>';
//   }

//   function wire(row) {
//     row.querySelectorAll('.cart-recs__add').forEach(function (b) {
//       if (b.dataset.wired) return;
//       b.dataset.wired = '1';
//       b.addEventListener('click', function () {
//         b.disabled = true; b.textContent = 'Adding…';
//         fetch(root() + 'cart/add.js', {
//           method: 'POST',
//           headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
//           body: JSON.stringify({
//             items: [{ id: Number(b.dataset.id), quantity: 1 }],
//             sections: ['cart-drawer', 'cart-icon-bubble'],
//             sections_url: window.location.pathname
//           })
//         }).then(function (response) {
//           if (!response.ok) throw new Error('Unable to add recommendation');
//           return response.json();
//         }).then(renderDrawer)
//           .catch(function (error) {
//             console.error('[Cart recommendations]', error);
//             b.disabled = false;
//             b.textContent = 'Add to cart';
//           });
//       });
//     });
//   }

//   function renderDrawer(state) {
//     var drawer = document.querySelector('cart-drawer');
//     if (!drawer || typeof drawer.renderContents !== 'function' || !state.sections) {
//       window.location.reload();
//       return;
//     }

//     drawer.renderContents(state);
//     setTimeout(fillAll, 0);
//   }

//   function fill(box) {
//     var row = box.querySelector('.cart-recs__row');
//     if (!row || row.dataset.busy) return;
//     if (row.children.length) return;           // already filled, skip
//     var id = box.dataset.baseId;
//     if (!id) return;

//     if (cache[id]) {                            // re-render: inject instantly, no flicker
//       row.innerHTML = cache[id]; wire(row); return;
//     }

//     row.dataset.busy = '1';
//     fetch(root() + 'recommendations/products.json?product_id=' + id + '&limit=8&intent=related')
//       .then(function (r) { return r.json(); })
//       .then(function (d) {
//         delete row.dataset.busy;
//         if (!d.products || !d.products.length) { box.style.display = 'none'; return; }
//         var html = d.products.map(card).join('');
//         cache[id] = html;
//         row.innerHTML = html; wire(row);
//       })
//       .catch(function () { delete row.dataset.busy; });
//   }

//   function fillAll() {
//     document.querySelectorAll('.cart-recs').forEach(fill);
//   }

//   // Debounced observer — refills whenever the drawer re-renders
//   var t;
//   function schedule() { clearTimeout(t); t = setTimeout(fillAll, 50); }

//   function start() {
//     fillAll();
//     new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
//     ['cart:updated', 'cart:refresh', 'product:added'].forEach(function (eventName) {
//       document.addEventListener(eventName, schedule);
//     });
//   }

//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', start);
//   } else { start(); }
// })();


(function () {
  var cache = {}; // baseId -> rendered HTML (no flicker on re-render)

  function root() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  function card(p) {
    var price = '₹' + (p.price / 100).toFixed(2).replace(/\.00$/, '');
    return '<div class="cart-recs__item">'
      + '<a class="cart-recs__img" href="' + p.url + '"><img loading="lazy" src="' + p.featured_image + '" alt="' + (p.title || '').replace(/"/g, '&quot;') + '"></a>'
      + '<div class="cart-recs__info">'
      + '<a class="cart-recs__name" href="' + p.url + '">' + p.title + '</a>'
      + '<span class="cart-recs__price">' + price + '</span>'
      + '<button type="button" class="cart-recs__add" data-id="' + p.variants[0].id + '">Add to cart</button>'
      + '</div></div>';
  }

  function wire(row) {
    row.querySelectorAll('.cart-recs__add').forEach(function (b) {
      if (b.dataset.wired) return;
      b.dataset.wired = '1';
      b.addEventListener('click', function () {
        b.disabled = true; b.textContent = 'Adding…';
        fetch(root() + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: b.dataset.id, quantity: 1 }] })
        }).then(function () { return refreshDrawer(); })
          .catch(function () { window.location.reload(); });
      });
    });
  }

  // Re-render the cart drawer contents via Section Rendering API
  function refreshDrawer() {
    var current = document.querySelector('cart-items-component[data-section-id]');
    if (!current) { window.location.reload(); return; }
    var sid = current.dataset.sectionId;
    return fetch(root() + '?section_id=' + sid)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('cart-items-component');
        if (fresh) { current.innerHTML = fresh.innerHTML; fill(); }
      })
      .catch(function () { window.location.reload(); });
  }

  function fill() {
    var box = document.querySelector('.cart-recs');
    if (!box) return;
    var row = box.querySelector('.cart-recs__row');
    if (!row || row.dataset.busy) return;
    if (row.children.length) return;           // already filled, skip
    var id = box.dataset.baseId;
    if (!id) return;

    if (cache[id]) {                            // re-render: inject instantly, no flicker
      row.innerHTML = cache[id]; wire(row); return;
    }

    row.dataset.busy = '1';
    fetch(root() + 'recommendations/products.json?product_id=' + id + '&limit=8&intent=related')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        delete row.dataset.busy;
        if (!d.products || !d.products.length) { box.style.display = 'none'; return; }
        var html = d.products.map(card).join('');
        cache[id] = html;
        row.innerHTML = html; wire(row);
      })
      .catch(function () { delete row.dataset.busy; });
  }

  // Debounced observer — refills whenever the drawer re-renders
  var t;
  function schedule() { clearTimeout(t); t = setTimeout(fill, 50); }

  function start() {
    fill();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else { start(); }
})();
